// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal__content[data-v-a60f3f46]{padding:50px;margin-bottom:95px}[data-v-a60f3f46] .mx-input{height:38px !important}[data-v-a60f3f46] .icon-new-calendar{background-color:var(--color-main-background);border:none;padding:6px;margin-top:17px;cursor:default}", ""]);
// Exports
module.exports = exports;
